AuthRoute = require 'mixins/authenticated-route'

App.SettingsStaffRoute = Em.Route.extend AuthRoute,
  model: (params) ->
    Ember.RSVP.hash
      restaurants: @store.find('restaurant')
      cooking_lines: @store.find 'cooking_line'
      business_roles: @store.find 'business_role'

  setupController: (controller, hash) ->
    controller.setProperties hash
